import {commitMutation, type Environment, graphql} from 'react-relay'

import {UNSET_ID} from '../components/IssueTypePicker'
import {updateIssueIssueTypeById} from '../relay-tsq-interop'
import type {updateIssueIssueTypeBulkSharedMutation} from './__generated__/updateIssueIssueTypeBulkSharedMutation.graphql'

type InputArgs = {ids: string[]; issueTypeId?: string; unsetIssueType?: boolean}

export function commitUpdateIssueIssueTypeBulkSharedMutation({
  environment,
  input: {ids, issueTypeId},
  onCompleted,
  onError,
}: {
  environment: Environment
  input: {ids: string[]; issueTypeId: string}
  onCompleted?: (response: updateIssueIssueTypeBulkSharedMutation['response']) => void
  onError?: (error: Error) => void
}) {
  const inputHash: InputArgs = {ids}
  if (issueTypeId !== UNSET_ID) inputHash.issueTypeId = issueTypeId
  else inputHash.unsetIssueType = true

  return commitMutation<updateIssueIssueTypeBulkSharedMutation>(environment, {
    mutation: graphql`
      mutation updateIssueIssueTypeBulkSharedMutation($input: UpdateIssuesBulkInput!) @raw_response_type {
        updateIssuesBulk(input: $input) {
          jobId
        }
      }
    `,
    variables: {
      input: inputHash,
    },
    updater: store => updateIssueIssueTypeById(store, ids, inputHash.issueTypeId),
    optimisticUpdater: store => updateIssueIssueTypeById(store, ids, inputHash.issueTypeId),
    onCompleted: response => onCompleted && onCompleted(response),
    onError: error => onError && onError(error),
  })
}
